import React from "react";
import { Check } from "lucide-react";

const REASONS = [
  "Verified Yoga Teachers",
  "Personalized Guidance",
  "Online From Anywhere",
  "Class Times in Your Timezone",
  "Free 15-Minute Consultation",
  "No Obligation to Book",
];

export default function TrustReasonsSection() {
  return (
    <section
      className="bg-white border-y border-gray-100"
      aria-labelledby="trust-reasons-heading"
    >
      <div className="container mx-auto px-4 py-12 md:py-14">
        <h2
          id="trust-reasons-heading"
          className="text-center text-2xl font-black tracking-tight text-gray-900 md:text-3xl"
        >
          Why Learn Through YogaRetreatsBooking?
        </h2>

        <ul className="mx-auto mt-8 grid max-w-3xl gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {REASONS.map((label) => (
            <li
              key={label}
              className="flex items-center gap-2.5 rounded-xl bg-gray-50/80 px-3.5 py-3 text-sm font-medium text-gray-800"
            >
              <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-emerald-50 text-emerald-700">
                <Check size={14} strokeWidth={2.5} />
              </span>
              {label}
            </li>
          ))}
        </ul>

        <p className="mx-auto mt-6 max-w-2xl text-center text-xs leading-relaxed text-gray-500">
          Verified teachers complete our instructor onboarding and submit certification details for
          review before their profile is listed.
        </p>
      </div>
    </section>
  );
}
